import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {

  public loading:boolean = false;
  public searchList:any=[];
  public search:any='';


  constructor(public router: Router, public service: GlobalService) {
    this.searchText();
  }

  searchText(){
    // const url = ""; 
    // this.service.PostApis(localStorage.getItem('grw_serachText'),url).subscribe(((response:any)=>{
    //   if(response.success ==1) { 

    //   } else {
    //     this.loading=false;
    //   }
    // }), (error) => { this.loading =false; });
  }
}
